export default {
  install(Vue, options) {
    Vue.prototype.$ShuLiangToolTip = function(value, leixing) {
      // if (leixing == 1) return value < 1000; //专版单页 提示
      // if (leixing == 107) return value >= 500; //数码单页 提示

      let Tip = false;
      switch (leixing) {
        case 1: //专版单页
          Tip = value < 1000;
          break;
        case 107: //数码单页
          Tip = value >= 500;
          break;
        default:
          Tip = false;
          break;
      }
      return Tip;
    };
  }
};



// WEBPACK FOOTER //
// ./src/js/func.js